import { request } from 'root/common/request';
import config from 'root/common/config/config';

/**
 *  获取用户信息列表
 */
export function getUserDistrictFn(data, options = {}) {
    return request({
        url: config.api.getIpConfig,
        method: 'get',
        data: data,
        isNeedToken: true,
        isShowCatchErr: false,
        isNeedLoading: false,
        ...options,
    });
}
